<template>
  <div
    @keydown.esc="closeUserTerms"
    ref="userTerms"
    tabindex="0"
    class="lite-lp-popup lite-lp-popup-login-overlay"
    id="lite-lp-popup-user-terms"
    autofocus
  >
    <div class="lite-lp-popup-content lite-lp-login-popup lite-lp-terms-of-use-popup">
      <header class="popup-header">
        <a
          class="lite-lp-popup-close"
          id="close-login"
          @click="closeUserTerms"
        ></a>
        <h2 class="lite-lp-popup-title">
          {{ $t("TERMS_OF_USE") }}
        </h2>
      </header>
      <div class="terms-wrap" v-html="$t('TERMS_OF_USE_DATA')">
        <br /><br /><br /><br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'userTerms',

  mounted () {
    this.$refs.userTerms.focus()
  },

  methods: {
    closeUserTerms () {
      this.$router.push({ name: 'logIn' })
    }
  }
}
</script>

<style lang="scss" scoped>
  /* width */
  ::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #C8C8C8;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

.lite-lp-terms-of-use-popup {
  max-width: 950px;
  overflow: auto;
  height: 85vh;
  margin: auto;
  background: white;
}
</style>
